import './count_all_supplierAwardedOffers_notClosed.css';

import React, { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import {makeStyles} from '@mui/styles';
import Widget_count_elements from '../widget_count_elements/widget_count_elements'

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
});

const columns = [
    { id: 'Objet', label: "Objet d'appel", minWidth: 0 },
    { id: 'direction', label: "Direction", minWidth: 0 },
    { id: 'categorie', label: "Famille d'achat", minWidth: 0 },
    { id: 'amount', label: "Montant", minWidth: 0 },
  ];
  

function Offers({offers,getCategorieById}){
    
    return(
        <>
        {
            offers.map((offer,index1) => (
                <TableRow key={offer.offer_id+"col"+index1}>
                    <TableCell align="left">{offer.object}</TableCell>
                    <TableCell align="left">{offer.direction}</TableCell>
                    <TableCell align="left">{getCategorieById(offer.purchase_family)}</TableCell>
                    <TableCell align="center">{offer.estimation+" MAD"}
                    </TableCell>
                </TableRow>                
             ))
        }
        </>
    );
}


const Count_all_supplierAwardedOffers_notClosed = ({categories,data})=>{

    const classes = useStyles();
    const [show_elemnts,setShowing_elements] = useState(false);


    function getCategorieById(id){
        var categorie="";
        categories.map((catg)=>{
          if(catg.id_category === id) categorie = catg.name;
        })
        return categorie;
    }



//////////////////////
/////////////////////////////////////////////////////////
///////////////////////////////////

  return (
    <>
      {
        show_elemnts!==true
          ?<Widget_count_elements setShowing_elements={setShowing_elements} elements_number={data.count} fontColor="rgb(59 124 130)" progress={data.progress} />
          :<TableContainer className="offers_totalAmount_widget" component={Paper} onContextMenu={(e) => {e.preventDefault();setShowing_elements(false)}} style={{cursor:'pointer'}} onTouchStartCapture={(e)=>{e.stopPropagation();setShowing_elements(false)}} >
              <Table className={classes.table} aria-label="sticky table">
                  <TableHead>
                  <TableRow>
                      {
                          columns.map((column) => (
                              <TableCell key={column.id} align="left">{column.label}</TableCell>
                          ))
                      }
                  </TableRow>
                  </TableHead>
                  <TableBody>
                  {
                      data.last_offers.length!=0
                      ?
                      <>
                          <Offers offers={data.last_offers} getCategorieById={getCategorieById} />
                      </>
                              
                      :<div style={{margin:"10px",fontSize:".8rem",width:'100%', textAlign:"center",alignContent:"center"}}>Aucun offre disponible</div>
                  }
                  </TableBody> 
              </Table>
          </TableContainer>
      }
    </>
  );
}

export default React.memo(Count_all_supplierAwardedOffers_notClosed);
